// extracted by mini-css-extract-plugin
export default {"title_box":"AboutChildComponent_title_box__lgdX+","img_box":"AboutChildComponent_img_box__xECEn","single_img":"AboutChildComponent_single_img__K788g"};